<div class="d-flex align-items-center mb-2">
  <span class="fw-bold">
    {{ 'page.invoicing.invoice_attachments' | translate }}
  </span>
</div>

<nz-table
  #attachmentsTable
  [nzData]="displayedRows()"
  [nzSize]="'small'"
  [nzTableLayout]="'fixed'"
  [nzOuterBordered]="true"
  [nzFrontPagination]="false"
  [nzShowPagination]="false"
>
  <thead>
    <tr class="bg-white">
      @if (!compact()) {
        <th
          nzWidth="3.125rem"
          [nzChecked]="allSelected"
          [nzIndeterminate]="indeterminate"
          (nzCheckedChange)="onAllChecked($event)"
          [nzDisabled]="areCheckboxesDisabled"
        ></th>
      }
      <th>
        {{ 'page.invoicing.invoice_attachments.file_name' | translate }}
      </th>
      <th [nzWidth]="compact() ? '3.125rem' : '8rem'">
        {{ 'page.invoicing.invoice_attachments.file_size' | translate }}
      </th>
      <th [nzWidth]="compact() ? '6rem' : ''">
        {{ 'page.invoicing.invoice_attachments.created_at' | translate }}
      </th>
      <th>
        {{ 'page.invoicing.invoice_attachments.type' | translate }}
      </th>
      <th>
        {{ 'page.invoicing.invoice_attachments.shifts' | translate }}
      </th>
    </tr>
  </thead>
  <tbody cdkDropList (cdkDropListDropped)="drop($event)">
    @for (attachment of displayedRows(); track attachment) {
      <tr cdkDrag class="cursor-grab">
        @if (!compact()) {
          <td
            [nzDisabled]="areCheckboxesDisabled"
            [nzChecked]="
              invoiceAttachmentsHelperService
                .setOfCheckedRowIdsSignal()
                .has(attachment.id)
            "
            (nzCheckedChange)="onItemChecked(attachment.id, $event)"
          ></td>
        }
        <td nzEllipsis>
          <a
            class="link-dark"
            (click)="previewFile(attachment)"
            nz-tooltip
            [nzTooltipTitle]="
              !isPreviewVisibleSignal() ? attachment.fileName : ''
            "
          >
            {{ attachment.fileName }}
          </a>
        </td>
        <td>
          {{ attachment.sizeInBytes | bytesToMb | localizedNumber: 'decimal' }}
        </td>
        <td>
          @if (compact()) {
            {{ attachment.createdAt | localizedDateFormat }}
          } @else {
            {{ attachment.createdAt | localizedDateTimeFormat }}
          }
        </td>
        <td>
          <nz-tag
            nzColor="default"
            nz-tooltip
            class="fit-to-container"
            [nzTooltipTitle]="
              attachment.attachmentType === ShiftAttachmentType.Report
                ? ('page.invoicing.invoice_attachments.type.tooltip.REPORT'
                  | translate)
                : ''
            "
          >
            @if (attachment.attachmentType === ShiftAttachmentType.Other) {
              {{
                'page.invoicing.invoice_attachments.type.OTHER.other'
                  | translate
              }}
            } @else {
              {{
                `page.invoicing.invoice_attachments.type.${attachment.attachmentType}`
                  | translate
              }}
            }
          </nz-tag>
        </td>
        <td>
          <div class="flex flex-wrap gap-1">
            <nz-tag
              nzColor="default"
              class="cursor-pointer fit-to-container"
              (click)="openDrawer(attachment.shiftDetails[0].shiftId)"
            >
              {{ attachment.shiftDetails[0].name }}
            </nz-tag>
            @if (attachment.shiftDetails.length > 1) {
              <nz-tag
                nzColor="default"
                class="cursor-pointer"
                nz-dropdown
                [nzDropdownMenu]="action"
                [nzTrigger]="'click'"
              >
                <span>+{{ attachment.shiftDetails.length - 1 }}</span>
              </nz-tag>
              <nz-dropdown-menu #action="nzDropdownMenu">
                <ul nz-menu>
                  @for (
                    shiftDetail of attachment.shiftDetails | slice: 1;
                    track shiftDetail
                  ) {
                    <li nz-menu-item (click)="openDrawer(shiftDetail.shiftId)">
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <span class="shift-field-name">{{
                          shiftDetail.name
                        }}</span>
                      </div>
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
@if (isDrawerVisibleSignal()) {
  <wilson-shift-drawer
    [selectedShift]="selectedDrawerShiftSignal()"
    (closeDrawer)="isDrawerVisibleSignal.set(false)"
    (closeDrawerAndReloadList)="closeDrawerAndReloadList()"
    (refresh)="refreshShiftAttachments.emit()"
    (accept)="acceptShift($event)"
  ></wilson-shift-drawer>
}
